var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeActive = function SvgHomeActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "home-active_svg__a",
    d: "M0 0h60v60H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-6 -6)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "home-active_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#home-active_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    stroke: "#111",
    strokeWidth: 2,
    d: "m30 7.302 23 19.166V53H35V39H25v14H7V26.468z",
    mask: "url(#home-active_svg__b)"
  }))));
};
export default SvgHomeActive;